module.exports = __webpack_public_path__ + "img/shopping-cart.0c482d17.svg";